/* eslint-disable import/prefer-default-export */
import _ from 'lodash';

import * as api from '../../api';
import * as types from '../action.types';

import { addMessage } from './message.actions';
import { fetchSessionFile } from './session.actions';
import { resetState } from './status.actions';

const createVirtualFileStart = sessionId => ({
  type: types.CREATE_VIRTUAL_FILE_START,
  payload: {
    sessionId,
  },
});

const createVirtualFileDone = () => ({
  type: types.CREATE_VIRTUAL_FILE_DONE,
});

const createJoin = (sourceFilename, sourceHeader, targetFilename, targetHeader, order, data) => ({
  type: types.CREATE_JOIN_ITEM,
  payload: {
    join: {
      sourceFilename,
      targetFilename,
      sourceHeader,
      targetHeader,
      order,
    },
    ...data,
  },
});

function saveVirtualFile({ sessionId, filename, headersToInclude, fileId }) {
  return (dispatch, getState) => {
    const rules = _.map(getState().rules.rules, rule => ({
      attribute: rule.attribute,
      text: rule.text,
      index: rule.index,
    }));

    const headers = Object.values(headersToInclude).flat();
    const metadata = _.pickBy(getState().metadata, col => col.custom || headers.includes(col.key));

    return api.saveSession(sessionId, {
      sessionId,
      ...(filename ? { filename } : { filename: getState().filename }),
      ...(fileId ? { fileId } : {}),
      virtualFile: true,
      savedByUser: true,
      rules,
      metadata,
      joins: _.values(getState().joins.joins),
    }).then(() => {
      dispatch(addMessage('success', 'New file created'));
    }).catch(({ message }) => {
      dispatch(addMessage('error', message));
    });
  };
}

function createJoinItem(sessionId, join, offset = 0, limit = 50) {
  return (dispatch, getState) => {
    const {
      sourceFile,
      targetFile,
      sourceHeader,
      targetHeader,
      order,
    } = join;

    return api.fetchSessionFile(sessionId, targetFile, offset, limit)
      .then((data) => {
        const { files } = getState().sessions[sessionId];
        const sourceFilename = files[sourceFile].filename;
        const targetFilename = files[targetFile].filename;

        dispatch(createJoin(
          sourceFilename,
          sourceHeader,
          targetFilename,
          targetHeader,
          order,
          data,
        ));
      }).catch((error) => {
        dispatch(addMessage('error', error.message));
      });
  };
}

export function updateVirtualFile(sessionId, fileId, newJoins, headersToInclude) {
  return async (dispatch) => {
    dispatch(createVirtualFileStart(sessionId));
    await dispatch(fetchSessionFile(sessionId, fileId, true, 0, 2));
    await Promise.all(newJoins.map(join => (dispatch(createJoinItem(sessionId, join, 0, 2)))))
    await dispatch(saveVirtualFile({ sessionId, headersToInclude, fileId }));
    dispatch(resetState());
    dispatch(createVirtualFileDone());
  }
}

export function createVirtualFile(sessionId, filename, joins, headersToInclude, offset = 0, limit = 2) {
  return async (dispatch) => {
    dispatch(createVirtualFileStart(sessionId));
    await dispatch(fetchSessionFile(sessionId, joins[0].sourceFile, true, offset, limit));
    await Promise.all(joins.map(join => (
      dispatch(createJoinItem(sessionId, join, offset, limit))
    )));
    await dispatch(saveVirtualFile({ sessionId, filename, headersToInclude }));
    dispatch(resetState());
    dispatch(createVirtualFileDone());
  };
}
